import { Component } from '@angular/core';
import { ICellEditorAngularComp, ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { AgGridService } from '../ag-grid.service';
import { ToastrService } from 'ngx-toastr';
import { SendNotification } from '../ag-grid.model';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { CommonPopupComponent } from 'src/app/shared/common-popup/common-popup.component';

@Component({
  selector: 'app-whatsapp-icon-renderer',
  templateUrl: './whatsapp-icon-renderer.component.html',
  styleUrls: ['./whatsapp-icon-renderer.component.scss']
})
export class WhatsappIconRendererComponent implements ICellRendererAngularComp {
  public params: ICellRendererParams ;
  sendNotifications = new SendNotification()

  constructor(   
    public agGridService: AgGridService,
    public toaster: ToastrService,
    private modalService : NgbModal,
    ){

  }

  agInit(params: ICellRendererParams ): void {
    this.params = params;
  }

  refresh(): boolean {
    return false;
  }


  handlePrintClick(params): void {
    const customEvent = new CustomEvent('printButtonClick', {
      detail: { data: params },
    });
    this.params.api.dispatchEvent(customEvent);
  }
  clickOnWhatsapp(params){
    console.log( params);
    const selectedData = { data: [params?.data?.id], notificationTypeId: 2 };
    this.sendNotification(selectedData)

  }
  sendNotification(selectedData){
    if(this.params.data.contactNo !== ''){
    this.sendNotifications.notificationTypeId = selectedData.notificationTypeId;
    this.sendNotifications.id  = selectedData.data;
    this.agGridService.sendNotification(this.sendNotifications).subscribe(res => {
      console.log(res);
      if (res.isSuccess) {
        this.toaster.success(res.message)
      }else{
        this.toaster.error(res.message)
  
      }
    })
  }else{
    this.toaster.error("Whatsapp is empty.")
  }
  }

  openConfirmationPopup(params): void {
    const modalOption: NgbModalOptions = {
      centered: true,
      backdrop: "static",
      keyboard: false,
      size: "sm",
    };
      const modalRef = this.modalService.open(CommonPopupComponent, modalOption);
      modalRef.componentInstance.sendToMailOrWhatsapp = 'whatsApp';
      modalRef.result.then((res) => {
       if(res){
      this.clickOnWhatsapp(params)
       }
      })
  }

}




